import { createContext, useContext, useMemo } from 'react';

const ContainerContext = createContext();

export const ContainerProvider = ({
  children,
  isSidebarOpen,
  setSidebarOpen,
}) => {
  const value = useMemo(
    () => ({ isSidebarOpen, setSidebarOpen }),
    [isSidebarOpen, setSidebarOpen],
  );

  return (
    <ContainerContext.Provider value={value}>
      {children}
    </ContainerContext.Provider>
  );
};

export const useContainerContext = () => useContext(ContainerContext);
